import * as THREE from 'three'
import * as TWEEN from '@tweenjs/tween.js'
import { gsap } from 'gsap'

import Shark from '.'

export default class SmoothTransition {
  private shark: Shark

  constructor(shark: Shark) {
    this.shark = shark
  }

  public center(isDefault :boolean) {
    const box = new THREE.Box3().setFromObject(this.shark.model.scene)
    const center = box.getCenter(new THREE.Vector3())

    let targetPosition : any;

    const position = {
      ...this.shark.model.scene.position,
    }

    if(isDefault){
      targetPosition = {
        x: this.shark.model.scene.position.x - center.x + 0.4,
        y: this.shark.model.scene.position.y - center.y,
        z: this.shark.model.scene.position.z - center.z - 5,
      }
    }
    else{
      targetPosition = {
        x: this.shark.model.scene.position.x - center.x ,
        y: this.shark.model.scene.position.y - center.y,
        z: this.shark.model.scene.position.z - center.z -2,
      }
    }

    const rotation = {
      x: this.shark.model.scene.rotation.x,
      y: this.shark.model.scene.rotation.y,
    }
    const targetRotation = {
      y: -0.628,
      x: 0.314,
    }

    const rotationSmooth = new TWEEN.Tween(rotation)
      .to(targetRotation, 3000)
      .easing(TWEEN.Easing.Back.Out)
      .onUpdate(() => {
        this.shark.model.scene.rotation.x = rotation.x
        this.shark.model.scene.rotation.y = rotation.y
      })

    const centerSmooth = new TWEEN.Tween(position)
      .to(targetPosition, 2500)
      .easing(TWEEN.Easing.Circular.Out)
      .onUpdate(() => {
        this.shark.model.scene.position.x = position.x
        this.shark.model.scene.position.y = position.y
        this.shark.model.scene.position.z = position.z
      })

      .onComplete(() => {
        this.shark.isScreenRelative = true
      })

    centerSmooth.start()
    rotationSmooth.start()
  }

  public removeAll() {
    TWEEN.removeAll()
  }

  public updateGUI() {
    const showButtons = gsap.to(
      ['#back-btn', '#reverse-btn', '#snapshot-btn'],
      {
        duration: 0.2,
        opacity: 1,
        display: 'block',
        ease: 'none',
        paused: true,
      }
    )

    try {
      showButtons.play()
    } catch (_) {}
  }

  public zoomIn(model: any) {
    const opacityTarget = { value: 1 }
    const opacity = { value: 0 }

    // Squiggles opacity
    const tweenVisible = new TWEEN.Tween(opacity)
      .to(opacityTarget, 1500)
      .easing(TWEEN.Easing.Back.Out)
      .onUpdate(() => {
        this.shark.world.squiggles?.group.children.forEach((item) => {
          const squiggle = item as THREE.Sprite
          const material = squiggle.material as THREE.SpriteMaterial

          material.opacity = opacity.value
        })
      })

    const positionTarget = {
      value: -12,
    }
    const position = { value: -30 }

    // Shark position
    const scaleSmooth = new TWEEN.Tween(position)
      .to(positionTarget, 1000)
      .easing(TWEEN.Easing.Circular.Out)
      .onUpdate(() => {
        model.scene.position.z = position.value
      })
      .onStart(() => {
        tweenVisible.start()
        this.updateGUI()
      })
    scaleSmooth.start()
  }

  public update() {
    TWEEN.update()
  }
}
